
<div *ngIf="pageDesignFlag">
  <div id="{{pageDesign.name}}" [ngStyle]="pageDesign.style">
    
    <div class="full-width">
    
      <!-- CUSTOM CODE SECTION -->
      <div *ngIf="customDesign">
      
        <div [innerHTML]="htmlText | sanitizeHtml"></div>

      </div>

      <!-- NON CUSTOM CODE SECTION -->
      <div *ngIf="!customDesign">

        <div *ngFor="let ele of pageDesign.element_flow" style="width: 100%;">

          <img *ngIf="ele.type=='image'" src="{{customService.imageUrl}}" [ngStyle]="ele.style">

          <p *ngIf="ele.type=='text' && ele.i18n_key == ''" [ngStyle]="ele.style">{{ele.text}}</p>
          <p *ngIf="ele.type=='text' && ele.i18n_key == 'selfie_result_text'" [ngStyle]="ele.style" i18n>Thanks for sharing your photo, our AI is now working to find the best products for you!</p>

          <button mat-raised-button *ngIf="ele.type=='button' && ele.i18n_key == ''" [ngStyle]="ele.style"
            (click)="customService.triggerFunction(ele)">{{ele.text}}</button>
            
          <button mat-raised-button *ngIf="ele.type=='button' && ele.i18n_key == 'selfie_result_continue_button'" [ngStyle]="ele.style"
          (click)="customService.triggerFunction(ele)" i18n>Let's go!</button>
          
          <button mat-raised-button *ngIf="ele.type=='button' && ele.i18n_key == 'selfie_result_retry_button'" [ngStyle]="ele.style"
            (click)="customService.triggerFunction(ele)" i18n>Retry</button>
    
          <div class="key-container" *ngIf="ele.type=='result-div'" [ngStyle]="ele.style">

            <div class="key-child-containers2" *ngFor="let result of selfieResult">

              <div class="key-child-container1" style="min-width: 50%;">

                <p class="feature-key">{{result.key}}</p>

              </div>

              <div>

                <p class="feature-value">:&nbsp;</p>

              </div>

              <div class="key-child-containers1">

                <p class="feature-value">{{result.value}}</p>

              </div>

            </div>
    
          </div>

        </div>
        
      </div>
  
    </div>

  </div>
</div>